import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  updateProductUpdate,
  UpdateProductUpdatePayload
} from '../api/updateProductUpdate';

export const useUpdateProductUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: UpdateProductUpdatePayload) => {
      return await updateProductUpdate(payload);
    },
    onSuccess: async (_data, variables) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ['products-all']
        }),
        queryClient.invalidateQueries({
          queryKey: ['product-updates', variables.userId, variables.productId]
        })
      ]);
    }
  });
};
